export default function CTASection() {
  const handleGetQuote = () => {
    window.REACT_APP_NAVIGATE('/contact');
  };

  const handleExplore = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-gradient-to-br from-[#1A1F2E] via-[#2A3F5F] to-[#1A1F2E] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#14B8A6] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#14B8A6] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
          Ready to Plan Your Perfect Muslim Family Holiday?
        </h2>
        <p className="text-xl text-gray-200 mb-10 leading-relaxed">
          Let our expert team create a tailor-made family holiday package with guaranteed halal food, prayer facilities, and family-friendly activities. Travel with confidence and peace of mind.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={handleGetQuote}
            className="px-8 py-4 bg-[#14B8A6] text-white font-semibold rounded-lg hover:bg-[#0F9B8E] transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 whitespace-nowrap cursor-pointer"
          >
            Get a Free Quote
          </button>
          <button
            onClick={handleExplore}
            className="px-8 py-4 bg-white text-[#1A1F2E] font-semibold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 whitespace-nowrap cursor-pointer"
          >
            Explore More Destinations
          </button>
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-8 text-white">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full">
              <i className="ri-restaurant-2-line text-2xl text-[#14B8A6]"></i>
            </div>
            <div className="text-left">
              <p className="text-sm text-gray-300">100% Halal</p>
              <p className="font-semibold">Guaranteed</p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full">
              <i className="ri-shield-check-line text-2xl text-[#14B8A6]"></i>
            </div>
            <div className="text-left">
              <p className="text-sm text-gray-300">Family-Safe</p>
              <p className="font-semibold">Destinations</p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-full">
              <i className="ri-ancient-pavilion-line text-2xl text-[#14B8A6]"></i>
            </div>
            <div className="text-left">
              <p className="text-sm text-gray-300">Prayer Facilities</p>
              <p className="font-semibold">Available</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}